import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import InlineDealerRow from "./InlineDealerRow";

interface Data {
    paragraphById: {
        type: Array<{
            targetId: string;
        }>;
    }
}

class InlineDealerParagraphQuery extends Query<Data, {id: string}> {}

const GET_PARAGRAPH = gql`
    query paragraphById($id: String!) {
        paragraphById(id: $id) {
            id
            ... on Paragraph {
                type {
                    targetId
                }
            }
        }
    }
`;

const InlineDealerParagraph = ({id, group, headline, gridType}) => (
    <InlineDealerParagraphQuery asyncMode query={GET_PARAGRAPH} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.paragraphById) return <div>{error || null}</div>;

            const type = data.paragraphById.type.targetId || '';
            const paragraphID = data.paragraphById.id;

            if ((type === 'component_top_dealers')) {
                return (<InlineDealerRow id={`${paragraphID}`} group={group} headline={headline} gridType={gridType}/>);
            }

            return null;
        }}
    </InlineDealerParagraphQuery>
);

InlineDealerParagraph.propTypes = {
    id: PropTypes.string.isRequired,
    group: PropTypes.string,
    headline: PropTypes.string,
    gridType: PropTypes.string
};

InlineDealerParagraph.defaultProps = {
    group: '',
    headline: '',
    gridType: 'horizontal'
};

export default InlineDealerParagraph;



// WEBPACK FOOTER //
// ./frontend/components/InlineDealer/InlineDealerParagraph.jsx